window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('bootstrap');

require('../../../node_modules/owl.carousel/dist/owl.carousel.min.js');

require('./custom');